var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{ref:"googleMap",staticClass:"google-map"}),(Boolean(this.maps) && Boolean(this.drawingManager))?[_vm._t("default",null,{"maps":_vm.maps})]:_vm._e(),_c('n-button',{on:{"click":_vm.deletePolygon}},[_vm._v("Удалить полигон")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }